import React, { useState } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";

const DateRange = (props) => {
    const [ date, setDate ] = useState({
        from:new Date() ,
        to:new Date() 
    })


    const onSetDate = (type,d) => {
        if (type === 'from') {
            if (moment(d).isAfter(date.to)){
                alert("Tanggal awal tidak bisa setelah tanggal akhir")
                return
            }

            if (moment(d).diff(moment(date.to), 'days') < -60) {
                alert("Tidak bisa memilih lebih dari 60 hari")
                return
            }
            setDate({...date, from:d})    
            props.onSetFromDate(d)
        } else {
            if (moment(date.from).isAfter(d)){
                alert("Tanggal akhir tidak bisa sebelum tanggal awal")
                return
            }

            if (moment(date.from).diff(moment(d), 'days') < -60) {
                alert("Tidak bisa memilih lebih dari 60 hari")
                return
            }
            setDate({...date, to:d})
            props.onSetToDate(d)
        }
    };

    return (
        <div className="row">
            <div className="col-6">
                <label>Tanggal Awal</label>
                <DatePicker
                    className="form-control col-md-12 mb-0"
                    onChange={e => onSetDate('from',e)}
                    selected={date.from}
                />
            </div>
            <div className="col-6">
                <label>Tanggal Akhir</label>
                <DatePicker
                    className="form-control col-md-12 mb-0"
                    onChange={e => onSetDate('to',e)}
                    selected={date.to}
                />
            </div>
        </div>
    )
}

export default DateRange